export default __webpack_public_path__ + "img/dahla_calendar.d3efa659.png";